import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HabitosAlimentares } from '../../models/HabitosAlimentares';
import axiosClient from '../../../shared/axios/axios-client';

@Injectable({
  providedIn: 'root'
})
export class HabitosAlimentaresService {
  private apiUrl = environment.apiUrl;

  async listarHabitosAlimentares(idPessoa: number): Promise<HabitosAlimentares | null> {
    const response = await axiosClient.get(
      `${this.apiUrl}/equilibria/habitos-alimentares/listar/${idPessoa}`
    );

    const lista = response.data?.data;
    return Array.isArray(lista) && lista.length > 0 ? lista[0] : null;
  }
}
